import type { ProgramEventInviteeRole } from './program-event';
import type { InviteTokenDataObject as InvitationTokenDataObject } from './service';

export type InvitationTokenKind =
  | 'event_attendee_invitation'
  | 'event_moderator_invitation'
  | 'event_presenter_invitation';

/* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
export class InvitationToken {
  static readonly mapToEventRole: Record<InvitationTokenKind, ProgramEventInviteeRole | undefined> = {
    event_attendee_invitation: 'attendee',
    event_moderator_invitation: 'moderator',
    event_presenter_invitation: 'presenter',
  };

  kind: InvitationTokenKind;
  subjectId: string;
  subjectType: 'Event';
  token: string;

  get eventInviteeRole() {
    return InvitationToken.mapToEventRole[this.kind];
  }

  constructor(data: InvitationTokenDataObject) {
    this.token = data.token;
    this.subjectType = data.subject_type;
    this.subjectId = data.subject_id;
    this.kind = data.kind;
  }
}
/* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
